import { render, staticRenderFns } from "./FormName.vue?vue&type=template&id=98b4cbe0"
import script from "./FormName.vue?vue&type=script&lang=js"
export * from "./FormName.vue?vue&type=script&lang=js"
import style0 from "./FormName.vue?vue&type=style&index=0&id=98b4cbe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports